// src/Routes.tsx
import React from "react";
import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import IDLogin from "./components/QRCodeChecker/IDLogin";
import PassKitChecker from "./components/PassKitChecker";
import NotFound from "./components/NotFoundPage";
import PrivilegePage from "./components/PrivilegePage/PrivilegePage";
import PrivilegeDescription from "./components/PrivilegeDescription/PrivilegeDescription";
import PassInfo from "./components/QRCodeChecker/PassInfo";

const AppRoutes: React.FC = () => {
  return (
    <Router>
      <Routes>
        <Route path="/:employeeId" element={<PrivilegePage />} />
        <Route
          path="/privilegeDescription"
          element={<PrivilegeDescription />}
        />
        <Route path="/pass/verify" element={<PassKitChecker />} />
        <Route path="/qrcode/verify" element={<IDLogin />} />
        <Route path="/pass/info" element={<PassInfo />} />
        <Route path="*" element={<NotFound />} />
      </Routes>
    </Router>
  );
};

export default AppRoutes;
